export default __webpack_public_path__ + "static/media/3_Paths_Desktop.910041ef.jpg";